import { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';

export default function Footer() {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    // Format time specifically for Poland (Mysłowice/Warsaw timezone)
    const formattedTime = time.toLocaleTimeString('pl-PL', {
        timeZone: 'Europe/Warsaw',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });

    return (
        <>
            <footer className="w-full bg-dark text-primary rounded-t-[4rem] px-6 md:px-16 pt-20 pb-24 md:pb-12 mt-[-4rem] relative z-10 flex flex-col items-center">

                <div className="w-full max-w-7xl flex flex-col md:flex-row justify-between items-center md:items-start border-b border-primary/10 pb-12 mb-12">

                    <div className="text-center md:text-left mb-10 md:mb-0">
                        <h2 className="font-heading font-bold text-4xl uppercase tracking-widest mb-2">TOBMAR</h2>
                        <p className="font-mono text-sm text-primary/60 uppercase mb-4">Eksperci od Dachów Płaskich</p>
                        <a href="tel:+48786148469" className="inline-flex items-center gap-3 font-heading font-black text-2xl lg:text-3xl tracking-widest text-accent hover:text-primary transition-colors">
                            <Phone size={24} strokeWidth={2.5} />
                            +48 786 148 469
                        </a>
                    </div>

                    <div className="flex flex-col items-center md:items-end gap-2 font-mono text-sm text-primary/60 uppercase">
                        <a href="#oferta" className="footer-link">Oferta</a>
                        <a href="#dlaczego-my" className="footer-link">Dlaczego My</a>
                        <a href="#proces" className="footer-link">Proces Wdrożeniowy</a>
                        <a href="#kontakt" className="hover:text-accent mt-4 bg-primary/10 px-4 py-1 rounded-full text-primary">Darmowa Wycena</a>
                    </div>

                </div>

                <div className="w-full max-w-7xl flex flex-col md:flex-row justify-between items-center text-xs font-mono text-primary/40 uppercase">

                    <div className="flex items-center gap-3 mb-6 md:mb-0">
                        <div className="w-2.5 h-2.5 bg-[#4ADE80] rounded-full animate-pulse shadow-[0_0_10px_#4ADE80]"></div>
                        <span>Mysłowice, PL — {formattedTime}</span>
                    </div>

                    <div>
                        &copy; {new Date().getFullYear()} TOBMAR. All rights reserved.
                    </div>
                </div>
            </footer>

            {/* Sticky Mobile CTA */}
            <div className="fixed bottom-0 left-0 w-full p-4 z-[9999] md:hidden pointer-events-none">
                <a
                    href="tel:+48786148469"
                    className="pointer-events-auto flex items-center justify-center gap-3 w-full bg-accent text-background font-heading font-bold text-lg uppercase tracking-widest py-4 rounded-2xl shadow-[0_-5px_20px_rgba(230,59,46,0.4)]"
                    style={{ minHeight: '48px' }}
                >
                    <Phone size={20} />
                    Zadzwoń Teraz
                </a>
            </div>
        </>
    );
}
